import { BasicSelect, IconButton } from "@/components/form"
import Icon from "@/components/Icon"
import { MarriageStatus } from "@/models"
import { faCheckCircle, faPen, faXmarkCircle } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { ref } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { getBooleanDisplayValue } from "./utils"

const formSectionStyling = css`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem 2rem;

	h6 {
		margin-bottom: 0;
	}

	@media (width < 992px) {
		grid-template-columns: 1fr;
	}
`

const ClaimInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()
	const editingStatus = ref<MarriageStatus | null>(null)

	return () => (
		<div class={formSectionStyling}>
			<div class="d-flex gap-1">
				<h6>ID:</h6>
				<h6 class="fw-bold">{state.fullClaim.Id}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Claim Ref:</h6>
				<h6 class="fw-bold">{state.fullClaim.ClaimRef}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Claim Reference:</h6>
				<h6 class="fw-bold">{state.fullClaim.ClaimReference}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Marriage Date:</h6>
				<h6 class="fw-bold">
					{state.fullClaim.MarriageDate !== null ? state.fullClaim.MarriageDate.toGBString() : `Unknown`}
				</h6>
			</div>
			{editingStatus.value ? (
				<div class="d-flex gap-1 wrap">
					<h6>Status:</h6>
					<BasicSelect
						options={Object.values(MarriageStatus)}
						value={editingStatus.value}
						setValue={(newStatus) => (editingStatus.value = newStatus)}
						defaultText="Please select a status"
						required
					/>
					<IconButton
						icon={faCheckCircle}
						color="success"
						onClick={() => {
							void state.updateClaimStatus(editingStatus.value!)
							editingStatus.value = null
						}}
					/>
					<IconButton icon={faXmarkCircle} color="danger" onClick={() => (editingStatus.value = null)} />
				</div>
			) : (
				<div class="d-flex  gap-1">
					<h6>Status:</h6>
					<h6 class="fw-bold">{state.fullClaim.Status}</h6>
					<Icon icon={faPen} onClick={() => (editingStatus.value = state.fullClaim.Status)} cursor="pointer" />
				</div>
			)}
			<div class="d-flex gap-1">
				<h6>Type:</h6>
				<h6 class="fw-bold">{state.fullClaim.Type}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Has Claimed Before?:</h6>
				<h6 class="fw-bold">{getBooleanDisplayValue(state.fullClaim.ClaimedBefore, "Unknown")}</h6>
			</div>
			{state.fullClaim.ClaimedBefore && (
				<div class="d-flex gap-1">
					<h6 class="fw-bold">{String(state.fullClaim.ClaimedBeforeTaxYears)}</h6>
				</div>
			)}
		</div>
	)
}

export default defineComponent(ClaimInformation)
